import React, { useEffect, useState } from "react";
import "./Tyre.css";
import Breadcrumb from "../../../../components/Breadcrum";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Services = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // ✅ Tyre Data
  const tyreData = [
    {
      id: 1,
      name: "DS01",
      outerImg: "/assets/img/pcr/outer-images/DH01.jpg", // ✅ normal image
      innerImg: "/assets/img/pcr/inner-images/DH01.jpg", // ✅ popup image
    },
    {
      id: 2,
      name: "DS02",
      outerImg: "/assets/img/pcr/outer-images/DH02.jpg",
      innerImg: "/assets/img/pcr/inner-images/DH02.jpg",
    },
    {
      id: 3,
      name: "DH05",
      outerImg: "/assets/img/pcr/outer-images/DH05.jpg",
      innerImg: "/assets/img/pcr/inner-images/DH05.jpg",
    },
    {
      id: 4,
      name: "DL01",
      outerImg: "/assets/img/pcr/outer-images/DL01.jpg",
      innerImg: "/assets/img/pcr/inner-images/DL01.jpg",
    },
    {
      id: 5,
      name: "DS01",
      outerImg: "/assets/img/pcr/outer-images/DS01.jpg",
      innerImg: "/assets/img/pcr/inner-images/DS01.jpg",
    },
  ];
  // ✅ Show Only First 4 Tyres
  const visibleTyres = tyreData.slice(0, 4);

  // ✅ TBR Tyre Data
  const tbrData = [

    {
      id: 1,
      name: "D902",
      outerImg: "/assets/img/Tbr/outer-images/D902.jpg",
      innerImg: "/assets/img/Tbr/inner-images/D902.jpg",
    },
    {
      id: 2,
      name: "DFA100",
      outerImg: "/assets/img/Tbr/outer-images/DFA100.jpg",
      innerImg: "/assets/img/Tbr/inner-images/DFA100.jpg",
    },
    {
      id: 3,
      name: "DFA101",
      outerImg: "/assets/img/Tbr/outer-images/DFA101.jpg",
      innerImg: "/assets/img/Tbr/inner-images/DFA101.jpg",
    },
    {
      id: 4,
      name: "DLD100",
      outerImg: "/assets/img/Tbr/outer-images/DLD100.jpg",
      innerImg: "/assets/img/Tbr/inner-images/DLD100.jpg",
    },
    {
      id: 5,
      name: "DLD100",
      outerImg: "/assets/img/Tbr/outer-images/DLD100.jpg",
      innerImg: "/assets/img/Tbr/inner-images/DLD100.jpg",
    },
  ];

  const visibleTbrTyres = tbrData.slice(0, 4);

  // Otr Tyres data 


  const otrData = [
    {
      id: 1,
      name: "DFA601",
      outerImg: "/assets/img/otr/outer-images/DFA601.jpg",
      innerImg: "/assets/img/otr/inner-images/DFA601.jpg",
    },
    {
      id: 2,
      name: "DFA602S",
      outerImg: "/assets/img/otr/outer-images/DFA602S.jpg",
      innerImg: "/assets/img/otr/inner-images/DFA602S.jpg",
    },
    {
      id: 3,
      name: "DS706",
      outerImg: "/assets/img/otr/outer-images/DS706.jpg",
      innerImg: "/assets/img/otr/inner-images/DS760.jpg",
    },
    {
      id: 4,
      name: "DSR656",
      outerImg: "/assets/img/otr/outer-images/DSR656.jpg",
      innerImg: "/assets/img/otr/inner-images/DSR656.jpg",
    },
  ];

  const visibleOtrTyres = otrData.slice(0, 4);


  // ✅ For Modal
  const [selectedTyre, setSelectedTyre] = useState(null);
  const openModal = (tyre) => setSelectedTyre(tyre);
  const closeModal = () => setSelectedTyre(null);

  return (
    <>
      <Breadcrumb
        title="Tyre"
        backgroundImage={"./assets/img/contact-banner.png"}
        height="40vh"
      />

      <section className="lyt-section tyers-section PCR-CATALOGUE">
        <div className="container">
          <h2 className="heading01 text-center">
            <span>PCR</span> CATALOGUE
          </h2>

          {/* ✅ Tyre Grid (only 4 tyres) */}
          <div className="tyre-grid">
            {visibleTyres.map((tyre) => (
              <div
                className="tyre-box"
                key={tyre.id}
                onClick={() => openModal(tyre)}
              >
                <div className="imageWrapper">
                  {/* ✅ normal image */}
                  <img src={tyre.outerImg} alt={tyre.name} className="image" />
                </div>
              </div>
            ))}
          </div>
          {/* ✅ View More Button */}
          {tyreData.length > 4 && (
            <div className="text-center mt-4">
              <button
                className="view-more-btn"
                onClick={() => navigate("/business/pcr-tyres")}
              >
                View More
              </button>
            </div>
          )}

          {/* ✅ Modal */}
          <Modal
            show={!!selectedTyre}
            onHide={closeModal}
            centered
            className="custom"
          >
            <Modal.Header closeButton>
              <Modal.Title>{selectedTyre?.name}</Modal.Title>
            </Modal.Header>

            <Modal.Body className="text-center">
              {/* ✅ popup image */}
              <img
                src={selectedTyre?.innerImg}
                alt={selectedTyre?.name}
                style={{ width: "100%", height: "auto" }}
              />
            </Modal.Body>

            {/* <Modal.Footer>
              <Button variant="secondary" onClick={closeModal}>
                Close
              </Button>
            </Modal.Footer> */}
          </Modal>
        </div>
      </section>

      <section className="lyt-section tyers-section TBR-CATALOGUE pt-0">
        <div className="container">
          {/* ✅ TBR CATALOGUE SECTION */}
          <h2 className="heading01 text-center">
            <span>TBR</span> CATALOGUE
          </h2>

          <div className="tyre-grid">
            {visibleTbrTyres.map((tyre) => (
              <div
                className="tyre-box"
                key={tyre.id}
                onClick={() => openModal(tyre)}
              >
                <div className="imageWrapper">
                  <img src={tyre.outerImg} alt={tyre.name} className="image" />
                </div>
              </div>
            ))}
          </div>

          {tbrData.length > 4 && (
            <div className="text-center mt-4">
              <button
                className="view-more-btn"
                onClick={() => navigate("/business/tbr-tyres")}
              >
                View More
              </button>
            </div>
          )}

          {/* ✅ Modal */}
          <Modal
            show={!!selectedTyre}
            onHide={closeModal}
            centered
            className="custom"
          >
            <Modal.Header closeButton>
              <Modal.Title>{selectedTyre?.name}</Modal.Title>
            </Modal.Header>

            <Modal.Body className="text-center">
              {/* ✅ popup image */}
              <img
                src={selectedTyre?.innerImg}
                alt={selectedTyre?.name}
                style={{ width: "100%", height: "auto" }}
              />
            </Modal.Body>

            {/* <Modal.Footer>
              <Button variant="secondary" onClick={closeModal}>
                Close
              </Button>
            </Modal.Footer> */}
          </Modal>
        </div>
      </section>

      <section className="lyt-section tyers-section OTR-CATALOGUE pt-0">
        <div className="container">
          <h2 className="heading01 text-center">
            <span>OTR</span> CATALOGUE
          </h2>

          <div className="tyre-grid">
            {visibleOtrTyres.map((tyre) => (
              <div
                className="tyre-box"
                key={tyre.id}
                onClick={() => openModal(tyre)}
              >
                <div className="imageWrapper">
                  <img src={tyre.outerImg} alt={tyre.name} className="image" />
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-4">
            <button
              className="view-more-btn"
              onClick={() => navigate("/business/otr-tyres")}
            >
              View More
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
